import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  setCart,
  setLoader,
  fetchCartProducts,
  showMobilePopup,
  triggeredMobilePopup,
  fetchProduct,
  fetchSeller
} from "../actions";
import history from "../history";
import { isTap2Buy, isGiftGuru } from "../helper/common";

class ProductItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      height: 0,
    };

    this.productImage = React.createRef();
  }

  updateDimensions = () => {
    const width = this.productImage.current.offsetWidth;

    let temp_height = 0;
    if (!this.props.product.is_giftcard) {
      temp_height = width * 1.2;
    } else if (this.props.product.is_giftcard) {
      temp_height = width * 0.62;
    }

    this.setState({ height: temp_height });
  };

  componentDidMount() {
    this.updateDimensions();

    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  addProductToCart = (product) => {
    if (product.type_id == "configurable") {
      history.push(`/product/${product.id}`);
    } else {
      this.props.setLoader(true, "Adding Product to Cart...");
      const product_data = {
        id: product.id,
        name: product.name,
        sku: product.sku,
        qty: 1,
        images: [product.image],
        price: parseFloat(product.price).toFixed(2),
        product_type: "simple",
      };
      this.props.setCart(product_data);
      this.props.fetchCartProducts();
      this.props.setLoader(false, null);
    }
  };

  renderPrice = () => {
    const product = this.props.product;
    let price = parseFloat(product.price);
    price = price.toFixed(2);

    return (
      <div className="product-price">
        {this.props.product.type_id === "configurable"
          ? `From $${price}`
          : `$${price}`}
      </div>
    );
  };

  renderButton = () => {
    return this.props.product.qty > 0 ? (
      <div className="product-add-to-cart-parent">
        <button
          className="product-add-to-cart"
          onClick={() => {
            if (this.props.auth.is_signed_in) {
              this.addProductToCart(this.props.product);
            } else {
              this.props.triggeredMobilePopup({
                pathname: null,
              });
              this.props.setLoader(true, "Fetching Product...")
              this.props.fetchProduct(this.props.product.id, () => {
                this.props.fetchSeller(this.props.product.id, () => {
                  this.props.setLoader(false, null)
                  this.props.showMobilePopup();
                })
              })
            }
          }}
        >
          {this.props.product.is_giftcard ? "Buy Now" : "Add To Cart"}
        </button>
      </div>
    ) : (
      <div className="product-out-of-stock">Out of Stock</div>
    );
  };

  render() {
    const product = this.props.product;
    let price = parseFloat(product.price);
    price = price.toFixed(2);

    return (
      <div className="product-tile">
        <Link to={`/product/${product.id}`}>
          <div className="product-image-wrapper">
            <img
              ref={this.productImage}
              className="product-image-photo"
              src={product.image}
              alt={product.name}
            />
          </div>
        </Link>
        <Link to={`/product/${product.id}`}>
          <div className="product-name">
            {product.name}
          </div>
        </Link>
        <div className="product-actions">
          <div className="product-price-wrapper">
            {this.renderPrice()}
          </div>
          <div className="product-button-wrapper">
            {this.renderButton()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps, {
  setCart,
  setLoader,
  fetchCartProducts,
  showMobilePopup,
  triggeredMobilePopup,
  fetchProduct,
  fetchSeller
})(ProductItem);
